import styled, { css } from "styled-components";
import { colors, fonts, header, transition } from "../../../../styles/variables";
import breakpoints from "../../../../styles/breakpoints";
import { extractNumberFromString } from "../../../../helpers/tools";

export const NavItem = styled.span`
  font-family: ${fonts.fontBauRegular};
  font-size: 18px;
  margin-right: 45px;
  flex-shrink: 0;
  flex-grow: 0;
  cursor: pointer;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
`;

export const SubHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  ${breakpoints.mdUp} {
    margin: 80px 0 20px;
  }
  margin: 60px 0 20px;
`;

export const LegendContainer = styled.div`
  width: 100%;
  padding: 0px 10px 0px 0px;
  display: flex;
  flex-direction: column;
`;

const faqQuestionTitle = css`
  font-size: 25px;
  line-height: 1;
  color: ${colors.black};
  font-family: ${fonts.fontInterstateBlackCompressed};
  ${breakpoints.smDown} {
    font-size: 22px;
  }
`;

export const StyledDiv = styled.div`
  > p {
    font-family: ${fonts.fontBauRegular};
    font-size: 18px !important;
    line-height: 1.75em !important;
    > a {
      border: 0px solid ${colors.black};
      border-bottom-width: 1px;
    }
    > strong {
      font-family: ${fonts.fontBauRegular};
      font-weight: bold;
      > a {
        border: 0px solid ${colors.black};
        border-bottom-width: 1px;
      }
    }
    > em {
      > a {
        border: 0px solid ${colors.black};
        border-bottom-width: 1px;
      }
    }
  }
  a {
    border: 0px solid ${colors.black};
    border-bottom-width: 1px;
    &:hover,
    &:focus {
      color: ${colors.coral};
      border: 0px solid ${colors.coral};
      border-bottom-width: 1px;
    }
  }
  .kg-card {
    // removes the horizontal margin for images in Guides Detail.
    margin-inline-start: 0px !important;
    margin-inline-end: 0px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .customColumnContainer {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    ${breakpoints.smDown} {
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
  .customColumnText {
    > ul {
      padding-left: 20px;
      margin-bottom: 10px;
    }
    > p,
    li {
      font-family: ${fonts.fontBauRegular};
      font-size: 18px !important;
      line-height: 1.75em !important;
      margin-bottom: 0px;
    }
    ${breakpoints.smDown} {
      margin-bottom: 10px;
    }
  }
  .customColumnImage {
    padding: 5px 15px;
  }
  .customColumn10 {
    width: 10%;
    ${breakpoints.smDown} {
      width: 30%;
    }
  }
  .customColumn20 {
    width: 20%;
    ${breakpoints.smDown} {
      width: 40%;
    }
  }
  .customColumn30 {
    width: 30%;
    ${breakpoints.smDown} {
      width: 40%;
    }
  }
  .customColumn40 {
    width: 40%;
    ${breakpoints.smDown} {
      width: 50%;
    }
  }
  .customColumn50 {
    width: 50%;
    ${breakpoints.smDown} {
      width: 100%;
    }
  }
  .customColumn60 {
    width: 60%;
    ${breakpoints.smDown} {
      width: 100%;
    }
  }
  .customColumn70 {
    width: 70%;
    ${breakpoints.smDown} {
      width: 100%;
    }
  }
  .customColumn80 {
    width: 80%;
    ${breakpoints.smDown} {
      width: 100%;
    }
  }
  .customColumn90 {
    width: 90%;
    ${breakpoints.smDown} {
      width: 100%;
    }
  }

  .faqContainer {
    ${breakpoints.mdUp} {
      margin-top: 80px;
    }
    margin-top: 40px;
    border: 0px solid ${colors.silver};
    border-top-width: 1px;
  }

  .faqHeaderTitle {
    padding: 25px 0 0;
    font-size: 30px;
    line-height: 0.9em;
    letter-spacing: -0.025em;
    -webkit-letter-spacing: -0.025em;
    color: ${colors.black};
    font-family: ${fonts.fontInterstateUltraBlack};
    word-break: break-word;
    text-transform: uppercase;
    ${breakpoints.smDown} {
      font-size: 25px;
    }
    margin-bottom: 25px;
  }

  .firstQuestionTitle {
    ${faqQuestionTitle};
  }

  .subsequentQuestionTitle {
    ${faqQuestionTitle};
    border: 0px solid ${colors.silver};
    border-top-width: 1px;
    padding: 25px 0 0;
  }

  .faqAnswer {
    font-family: ${fonts.fontBauRegular};
    font-size: 18px !important;
    line-height: 1.75em !important;
    margin-bottom: 20px;
  }
`;

export const HrDiv = styled.div`
  height: 1px;
  background-color: ${colors.silverSoft};
  ${breakpoints.mdUp} {
    margin: 80px 0;
  }
  ${breakpoints.mdDown} {
    margin: 60px 0;
  }
  width: 100%;
`;

const GridHolder = styled.div`
  ${breakpoints.mdUp} {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
  }
`;

export const LegendsGridHolder = styled(GridHolder)`
  ${breakpoints.mdUp} {
    width: 30%;
  }
`;

export const ContentGridHolder = styled(GridHolder)`
  ${breakpoints.mdUp} {
    width: ${(props) => (props.hasSubHeaders ? "70%" : "100%")};
    padding: ${(props) => (props.hasSubHeaders ? "0px 80px 40px" : "0px 0px 40px")};
  }
  padding: ${(props) => (props.hasSubHeaders ? "20px 20px" : "20px 0px")};
  ${breakpoints.mdDown} {
    padding: 20px 0px;
  }
`;

export const StickyDiv = styled.div`
  ${breakpoints.smUp} {
    position: sticky;
    position: -webkit-sticky;
    left: 0;
    top: ${(props) => (props.isHeaderShown ? header.mobileHeight : "0px")};
  }
  ${breakpoints.mdUp} {
    top: ${(props) =>
      props.isHeaderShown ? `${extractNumberFromString(header.desktopHeight) + 40}px` : "40px"};
  transition: ${transition.headerMenuBarTransition};
  padding: 20px 0 0;
`;

export const StyledGridHolderItemContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const ContentsHeaderTitle = styled.h3`
  font-size: 30px;
  line-height: 1.2;
  letter-spacing: -0.025em;
  -webkit-letter-spacing: -0.025em;
  color: ${colors.black};
  font-family: ${fonts.fontInterstateUltraBlack};
  word-break: break-word;
  text-transform: uppercase;
`;

export const TitleDiv = styled.div`
  padding: ${(props) => (props.addPaddingTop ? "60px 0 40px" : "20px 0 40px")};
`;

export const SubHeaderIcon = styled.img`
  display: inline-block;
  height: 25px;
  padding: 0 10px 0 0;
  ${breakpoints.smDown} {
    height: 22px;
  }
`;

export const LegendsIconContainer = styled.div`
  display: inline-block;
  height: 23px;
  padding: 2.5px 10px 0 0;
  min-width: 35px;
`;

export const LegendsIcon = styled.img`
  display: inline-block;
  height: 18px;
`;

export const PageTitle = styled.h1`
  font-size: 80px;
  line-height: 0.9em;
  font-family: ${fonts.fontInterstateBlackCompressed};
  word-break: break-word;
  ${breakpoints.smDown} {
    font-size: 60px;
  }
  ${breakpoints.xsDown} {
    font-size: 50px;
  }
`;

export const SubHeaderTitle = styled(ContentsHeaderTitle)`
  font-size: 30px;
  line-height: 0.9em;
  ${breakpoints.smDown} {
    font-size: 25px;
  }
`;

export const VideoContainer = styled.div`
  width: 100%;
`;
